import React from "react";
import { Drawer } from "antd";

export const ModalDialog = (props) => {
    const { isOpen, title, closeFn } = props;
    
    // Responsive width calculation
    const getResponsiveWidth = () => {
        if (window.innerWidth <= 480) {
            return '95vw';
        } else if (window.innerWidth <= 768) {
            return '85vw';
        } else {
            return 500;
        }
    };

    return (
        <Drawer 
            title={title} 
            onClose={closeFn} 
            open={isOpen} 
            width={getResponsiveWidth()}
            destroyOnClose={true}
            placement="right"
            className="responsive-drawer"
        >
            <div className="p-2">
                {props.children}
            </div>
        </Drawer>
    );
};